// @core/api/endpoints/authz/check.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CheckRequest,
  CheckResponse,
} from '../../../types/authz';

const BASE_PATH = '/authz';

/**
 * Check authorization
 * Determines if a specific user has a given relation with an object using the OpenFGA authorization model. This is the primary authorization check used throughout the application for access control decisions.
 */
export async function Check(
  data: CheckRequest,
  options?: RequestOptions
): Promise<CheckResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/check`;
  const requestOptions = options;
  return client.post<CheckResponse>(requestPath, data, requestOptions);
}
